import classNames from 'classnames';
import { LiHTMLAttributes, PropsWithChildren, useEffect, useRef } from 'react';

interface DropdownItemProps extends LiHTMLAttributes<HTMLLIElement> {
  label?: string;
  badgeLabel?: string;
  isSelected?: boolean;
  isActive?: boolean;
}

const DropdownItem = ({
  label,
  badgeLabel,
  isSelected,
  isActive,
  children,
  ...props
}: PropsWithChildren<DropdownItemProps>) => {
  const itemRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (!isActive) return;
    // the dropdown layer has a maxHeight and overflows — keep the active
    // option visible while navigating with the keyboard
    itemRef.current?.scrollIntoView?.({ block: 'nearest' });
  }, [isActive]);

  const content =
    !label && !badgeLabel && children ? (
      children
    ) : (
      <>
        <span className="sup-dropdown-item-label">{label}</span>
        <span className="sup-dropdown-item-badge-label">{badgeLabel}</span>
      </>
    );

  return (
    <li
      ref={itemRef}
      role="option"
      aria-selected={isSelected ?? false}
      {...props}
      className={classNames(
        'sup-dropdown-item',
        { selected: isSelected, active: isActive },
        props.className
      )}
    >
      {content}
    </li>
  );
};

export default DropdownItem;
